module.exports = __webpack_public_path__ + "static/media/SF_bm_engl_primaerlogo_vestland_neg.60183f56.pdf";